// import { Constants } from './constants';

export class ReusableClasses {
    commonConstantHigher: number = 5000;
    encryptionKey = '123456$#@$^@1ERF';
    decryptionKey = '123456$#@$^@1ERF';
    constructor() {

    }
    
    //SUMMARY
    //This function is used to get the first date of the month.
    getFirstDateOfMonth() {
        let date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        //let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return firstDay;
    }
  

     convertIntoRighString(strDate:string){
        var dateArray=strDate.split("-");
        let year=dateArray[0];
        let monthCount=dateArray[1];
        let date=dateArray[2];
        
        var month = new Array();
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sep";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        
        let monthName=month[(parseInt(monthCount)-1)];
        let newDateString=monthName+" "+date+", "+year;
        return newDateString;
     }
    

      generateRandomString(possible: string) {
        let lengthOfCode = 40;
        let text = "";
        for (let i = 0; i < lengthOfCode; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
          return text;
      }
      
}
